<template>
	<div class="projetocadastro">
	  	<loader object="#df3e46" v-show="progress" color1="#0db9d3" color2="#fff01f" size="6" speed="2.4" bg="#C0C0C0" objectbg="#0d0c0d" opacity="50" name="circular"></loader>
		<div class="container">
			<ol class="breadcrumb-arrow">
				<li>
					<a href="/home"><i class="fa fa-home"></i></a>
					<a href="/meuperfil/meusdados">Meus Dados</a>
				</li>
			</ol>
		</div>

		<div class="container mt-2">
			<div class="container mt-2">
				<card>
					<h4 slot="header" class="mb-0">Meus dados</h4>
					<form class="ml-3 mt-3 mr-3 mb-3">
						<div class="row">
							<div class="col-md-4">
								<div class="row d-flex justify-content-center">
									<div id="app">
										<my-upload
										field="img"
										@crop-success="cropSuccess"
										@crop-upload-success="cropUploadSuccess"
										@crop-upload-fail="cropUploadFail"
										v-model="show"
										:width="500"
										:height="500"
										url=""
										:noSquare="true"
										:params="params"
										:headers="headers"
										lang-type="pt-br"
										img-format="png"
										></my-upload>
										<img
										rel="preload"
										class="mx-auto d-block"
										:src="usuario.avatar"
										style="
											border-radius: 100%;
											width: 200px;
											height: 200px;
											float: left;
											text-align: center;
										"
										/>
									</div>
									<div class="col-lg-8 col-md-8 col-sm-8 col-xs-12 text-center mt-2">
										<a class="btn btn-info" @click="toggleShow">Alterar Avatar</a>
									</div>
								</div>
							</div>

							<div class="col-md-8">
								<div class="row">
									<div class="col-lg-12 col-md-8 col-sm-8 col-xs-12">

										<ul class="nav nav-tabs" id="myTab" role="tablist">
											<li class="nav-item">
												<a
													class="nav-link active"
													id="dados-tab"
													data-toggle="tab"
													href="#dados"
													role="tab"
													aria-controls="dados"
													aria-selected="true"
												>
													Meus Dados
												</a>
											</li>
											<li class="nav-item">
												<a
													class="nav-link"
													id="senha-tab"
													data-toggle="tab"
													href="#senha"
													role="tab"
													aria-controls="senha"
													aria-selected="true"
												>
													Trocar Senha
												</a>
											</li>
											<li class="nav-item">
												<a
													class="nav-link"
													id="estrutura-tab"
													data-toggle="tab"
													href="#estrutura"
													role="tab"
													aria-controls="estrutura"
													aria-selected="false"
												>
													Meus Grupos
												</a>
											</li>
										</ul>

										<div class="tab-content" id="myTabContent">
											
											<!-- Aba Meus Dados -->
											<div
												class="container mt-2 tab-pane fade show active"
												id="dados"
												role="tabpanel"
												aria-labelledby="dados-tab">
										
												<div class="row mt-3">
													<div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
														<label for="inputTitulo">
															Nome
															<el-tooltip content="Campo obrigatório" placement="top">
																<i style="font-size: 12px"
																	class="fas fa-exclamation-circle text-info ml-1">
																</i>
															</el-tooltip>
														</label>
														<div class="input-group">
															<div class="input-group-prepend mb-2">
															<span class="input-group-text"
																><i class="fas fa-align-left"></i
															></span>
															</div>
															<input
															id="inputTitulo"
															maxlength="200"
															tabindex="1"
															type="text"
															class="form-control mb-2"
															v-model="usuario.nome"
															placeholder="Informe seu nome"
															/>
														</div>
													</div>
													<div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
														<label for="inputData">
															Apelido
															<el-tooltip content="Campo obrigatório" placement="top"
															><i
																style="font-size: 12px"
																class="fas fa-exclamation-circle text-info ml-1"
															></i
															></el-tooltip>
														</label>
														<div class="input-group">
															<div class="input-group-prepend mb-2">
															<span class="input-group-text"
																><i class="fas fa-align-left"></i
															></span>
															</div>
															<input
															id="inputTitulo"
															maxlength="200"
															tabindex="1"
															type="text"
															class="form-control mb-2"
															v-model="usuario.apelido"
															placeholder="Informe o apelido"
															/>
														</div>
													</div>
												</div>

												<div class="row">
													<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
														<label for="inputData"> E-mail </label>
														<div class="input-group">
															<div class="input-group-prepend mb-2">
															<span class="input-group-text"
																><i class="fas fa-at"></i
															></span>
															</div>
															<input
															disabled
															id="inputTitulo"
															maxlength="200"
															tabindex="1"
															type="text"
															class="form-control mb-2"
															v-model="usuario.email"
															placeholder="Informe o nome do projeto"
															/>
														</div>
													</div>
												</div>

												<div class="row">
													<div class="col">
														<label for="inputDescricao"> Data de criação </label>
														<div class="input-group">
															<div class="input-group-prepend mb-2">
															<span class="input-group-text"
																><i class="far fa-calendar-alt"></i
															></span>
															</div>
															<input
															disabled
															type="text"
															class="form-control mb-2"
															v-model="usuario.dataCriacaoFmt"
															/>
														</div>
													</div>
													<div class="col">
														<label for="inputAprovacao"> Data de Aprovação </label>
														<div class="input-group">
															<div class="input-group-prepend mb-2">
																<span class="input-group-text"
																	><i class="far fa-calendar-alt"></i
																></span>
															</div>
															<input
															disabled
															id="inputAprovacao"
															type="text"
															class="form-control mb-2"
															v-model="usuario.dataAprovacaoFmt"
															/>
														</div>
													</div>
												</div>

												<div class="col-md-12 text-center mt-2">
													<button
														type="button"
														tabindex="9"
														class="btn btn-success btn-sm"
														@click="salvar()">
														<i class="far fa-edit mr-2"></i>
														Salvar alterações
													</button>
												</div>
											</div>
											<!-- Fim: MeusDados -->

											<!-- Aba Trocar Senha -->
											<div
												class="container mt-2 tab-pane fade show"
												id="senha"
												role="tabpanel"
												aria-labelledby="senha-tab">

												<div class="container mt-2">
													<form @submit.prevent="changePasswd">

														<div class="row mt-3">
															<div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
																<label for="inputTitulo">
																	Nova Senha
																	<el-tooltip content="Campo obrigatório" placement="top">
																		<i style="font-size: 12px"
																			class="fas fa-exclamation-circle text-info ml-1">
																		</i>
																	</el-tooltip>
																</label>
																<div class="input-group">
																	<div class="input-group-prepend mb-2">
																		<span class="input-group-text"><i class="fas fa-key"></i></span>
																	</div>
																	<input
																		id="inputTitulo"
																		maxlength="8"
																		tabindex="1"
																		type="password"
																		class="form-control mb-2"
																		v-model="user.password"
																		placeholder="Informe sua Nova Senha" />
																</div>
															</div>
														</div>
														<div class="row mt-3">
															<div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
																<label for="inputData">
																	Confirmar Nova Senha
																	<el-tooltip content="Campo obrigatório" placement="top">
																		<i style="font-size: 12px" class="fas fa-exclamation-circle text-info ml-1"></i>
																	</el-tooltip>
																</label>
																<div class="input-group">
																	<div class="input-group-prepend mb-2">
																		<span class="input-group-text"><i class="fas fa-key"></i></span>
																	</div>
																	<input
																		id="inputTitulo"
																		maxlength="8"
																		tabindex="2"
																		type="password"
																		class="form-control mb-2"
																		v-model="user.confirmpassword"
																		placeholder="Confirme a Nova Senha"
																	/>
																</div>
															</div>
														</div>
														<div class="col-md-12 text-center mt-2">
															<button
																type="button"
																tabindex="9"
																class="btn btn-success btn-sm"
																@click="changePasswd()">
																<i class="fa fa-save mr-2"></i>
																Trocar Senha
															</button>
														</div>
													</form>
												</div>

											</div>
											<!-- Fim: Trocar Senha -->

											<!-- Minha Estrutura -->
											<div
												class="container mt-2 tab-pane fade show"
												id="estrutura"
												role="tabpanel"
												aria-labelledby="estrutura-tab">

												<div class="listaGTDados">
													<div class="listaGTInterna" v-for="(gt, index) in listaGT" :key="gt.idgt">
														<strong>Grupo de Trabalho:</strong> {{ gt.nome }}<br/>
														<strong style="margin-left: 15px;"><i class="fas fa-caret-right"></i> Coordenação:</strong> {{ gt.coordenacao.nome }}<br/>
														<strong style="margin-left: 30px;"><i class="fas fa-caret-right"></i> Departamento:</strong> {{ gt.coordenacao.departamento.nome }}<br/>
													</div>
												</div>

											</div>
											<!-- Fim: Minha Estrutura -->

										</div>
									</div>
								</div>
							</div>
						</div>
					</form>
				</card>
			</div>
		</div>
  	</div>
</template>

<script>
import "@babel/polyfill";
import myUpload from "vue-image-crop-upload/upload-2.vue";
export default {
  components: {
    "my-upload": myUpload,
  },
  created() {
    this.carregarTelaProjeto();
  },
  data() {
    return {
		progress: true,
		current: 0,
		usuario: {
			nome: "",
			email: "",
			apelido: "",
			dataCriacaoFmt: "",
			tempoAprovação: "",
			imagemBase64: "",
		},
		user:{
			password : null
		},
		listaGT: [],
		show: false,
		params: {
			token: "123456798",
			name: "avatar",
			noSquare: true,
		},
		headers: {
			smail: "*_~",
		},
		imgDataUrl: "", // the datebase64 url of created image
    };
  },
	methods: {
		carregarTelaProjeto() {
			this.carregarUsuarioAtual();
			this.carregarUsuarioEstrutura();
		},
		carregarUsuarioAtual() {
			this.$clubApi.get("/user/info").then((response) => {
				this.usuario = response.data.object;
            }).finally(() =>{
                this.progress = false;
            })
		},
		carregarUsuarioEstrutura() {
			this.$clubApi.get("/user/estrutura").then((response) => {
				this.listaGT = response.data.object;
            }).finally(() =>{
                this.progress = false;
            })
		},
		toggleShow() {
			this.show = !this.show;
		},
		/**
		 * crop success
		 *
		 * [param] imgDataUrl
		 * [param] field
		 */
		 cropSuccess(imgDataUrl) {
			// Redimensionar e comprimir a imagem
			this.resizeAndCompressImage(imgDataUrl, 200, 200, 0.8)
			.then(compressedBase64 => {
				// Atribuir a imagem redimensionada e comprimida à propriedade usuario.avatar
				this.usuario.avatar = compressedBase64;
				this.usuario.imagemBase64 = compressedBase64;
			})
			.catch(error => {
				console.error('Erro ao redimensionar/comprimir imagem:', error);
			});
		},
		salvar() {
			if (this.validarSalvar()) {
				this.progress = true;
				this.$clubApi.post("/user/avatar", this.usuario).then((response) => {
					this.$toastr.success("Dados atualizados com sucesso!");
				})
				.catch((error) => {
					this.$toastr.error(error.response.data.msg);
				}).finally(() =>{
					this.progress = false;
				})
			}
		},
		validarSalvar() {
			if (this.usuario.nome == "") {
				this.$toastr.error("Nome é preenchimento obrigatório!");
				return false;
			}
			if (this.usuario.apelido == "") {
				this.$toastr.error("Apelido é preenchimento obrigatório!");
				return false;
			}
			return true;
		},
		cancelar() {
			location.href = "/meuperfil/meusdados";
		},

		/**
		 * upload success
		 *
		 * [param] jsonData  server api return data, already json encode
		 * [param] field
		 */
		cropUploadSuccess(jsonData, field) {
			console.log("-------- upload success --------");
			console.log(jsonData);
			console.log("field: " + field);
		},


		resizeAndCompressImage(base64Image, maxWidth, maxHeight, quality) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = function() {
        const canvas = document.createElement('canvas');
        let width = img.width;
        let height = img.height;

        // Redimensionar a imagem se necessário
        if (width > maxWidth) {
          height *= maxWidth / width;
          width = maxWidth;
        }
        if (height > maxHeight) {
          width *= maxHeight / height;
          height = maxHeight;
        }

        canvas.width = width;
        canvas.height = height;

        // Desenhar a imagem no canvas redimensionado
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);

        // Comprimir a imagem para o formato desejado
        const compressedBase64 = canvas.toDataURL('image/jpeg', quality); // Altere 'image/jpeg' para o formato desejado (ex: 'image/png')
        resolve(compressedBase64);
      };
      img.onerror = function(error) {
        reject(error);
      };
      img.src = base64Image;
    });
  },


		/**
		 * upload fail
		 *
		 * [param] status    server api return error status, like 500
		 * [param] field
		 */
		cropUploadFail(status, field) {
			console.log("-------- upload fail --------");
			console.log(status);
			console.log("field: " + field);
		},
        changePasswd(){
            if(this.user.password == null || this.user.password.trim() == ""){
				this.$toastr.error("Informe a nova senha!");
                return 
            }
            if(this.user.confirmpassword == null || this.user.confirmpassword.trim() == ""){
				this.$toastr.error("Informe a confirmação da nova senha!");
                return 
            }
            if(this.user.password != this.user.confirmpassword){
				this.$toastr.error("Senhas não conferem!");
                return 
            }
			this.progress = true;
            this.$clubApi.post('/user/update/passwd', {
                passwd : this.user.password
            }).then(() => {
				this.$toastr.success("Troca senha realizada com sucesso!");
                this.user = {
                    password: null,
                    confirmpassword: null
                }
            }).catch((error) => {
				this.$toastr.error(error.response.data.msg);
            }).finally(() =>{
                this.progress = false;
            })
        }
	},
};
</script>
<style>
.vue-image-crop-upload
  .vicp-wrap
  .vicp-step2
  .vicp-crop
  .vicp-crop-right
  .vicp-preview
  .vicp-preview-item {
  position: relative;
  padding: 5px;
  width: 229px;
  height: 119px;
  float: left;
  margin-right: 16px;
}
.listaGTDados {
    height: 245px;
    overflow-x: hidden;
    overflow-y: scroll;
    scrollbar-width: thin;
}
.listaGTInterna {
	padding-bottom: 15px; 
	margin-top: 15px; 
	border-bottom: 1px solid #c0c0c0
}
</style>
